export const DEFAULT_URL_PATH_VISIT_CONFIG = "{}";

function normalizeUrlPath(path) {
    if (!path) {
        return "/";
    }

    let normalizedPath = String(path).trim();
    if (!normalizedPath) {
        return "/";
    }

    if (normalizedPath.startsWith("http://") || normalizedPath.startsWith("https://")) {
        try {
            normalizedPath = new URL(normalizedPath).pathname;
        } catch (_) {
            return "/";
        }
    }

    normalizedPath = normalizedPath.replace(/^#/, "");

    if (!normalizedPath.startsWith("/")) {
        normalizedPath = `/${normalizedPath}`;
    }

    return normalizedPath.length > 1 ? normalizedPath.replace(/\/+$/, "") : normalizedPath;
}

export function isUrlPathAllowedByConfig(config, path) {
    try {
        const parsedConfig = JSON.parse(config || DEFAULT_URL_PATH_VISIT_CONFIG);
        if (!parsedConfig || typeof parsedConfig !== "object" || Array.isArray(parsedConfig)) {
            return true;
        }

        const normalizedPath = normalizeUrlPath(path);
        const matchingRule = Object.entries(parsedConfig).find(([configPath]) => {
            return normalizeUrlPath(configPath) === normalizedPath;
        });

        if (!matchingRule || typeof matchingRule[1] !== "boolean") {
            return true;
        }

        return matchingRule[1];
    } catch (_) {
        return true;
    }
}
